import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-background font-sans antialiased">
      <Navbar />
      {/* Main content area with padding for fixed navbar */}
      <main className="flex-1 pt-16 px-4 py-8">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
